import styled from 'styled-components'
import {maxWidth} from 'resources/react/core/theme'

export const Wrapper = styled.div`

select.minimal {
    background-image:
      linear-gradient(45deg, transparent 50%, gray 50%),
      linear-gradient(135deg, gray 50%, transparent 50%),
      linear-gradient(to right, #ccc, #ccc);
    background-position:
      calc(100% - 20px) calc(1em + -2px),
      calc(100% - 15px) calc(1em + -2px),
      calc(100% - 2.5em) 0.5em;
    background-size:
      7px 12px,
      7px 12px,
      0px 1.5em;
    background-repeat: no-repeat;
  }

  select {

    /* styling */
    background-color: white;
    border: thin solid blue;
    border-radius: 4px;
    display: inline-block;
    font: inherit;
    line-height: 1.5em;
    padding: 0.5em 3.5em 0.5em 1em;
  
    /* reset */
  
    margin: 0;      
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-appearance: none;
    -moz-appearance: none;
  }

.toggle-wrap {
    .toggled:after {
        border-bottom-color: transparent;
        border-bottom-width: 6px;
        border-left-color: transparent;
        border-left-width: 5px;
        border-right-color: transparent;
        border-right-width: 5px;
        border-style: solid;
        border-top-width: 0;
        bottom: 5px;
        height: 0;
        left: 0;
        margin-left: auto;
        margin-right: auto;
        position: absolute;
        right: 0;
        transition: border-bottom-color .25s ease-out;
        width: 0;
    }

    .toggled.is-active:before, .toggled:before {
        background-color: #09f;
    }
    
    .toggled:before {
        bottom: 0;
        height: 5px;
        left: 0;
        position: absolute;
        right: 0;
        transition: background-color .25s ease-out;
    }
    .toggled:after, .toggled:before {
        content: "";
    }
    .toggled.is-active:after, .toggled:after {
        border-bottom-color: #09f;
    }
    .toggled:after, .toggled:before {
        content: "";
    }    
}


.anchored-nav {
    -webkit-text-size-adjust: 100%;
    --sa-uid: '0-50804ad4-9f89-4ae5-4f1f-35566b298ffd';
    font-family: Lato;
    font-size: 16px;
    font-weight: 400;
    color: #fff;
    line-height: 1.4;
    box-sizing: border-box;
    margin-left: auto;
    margin-right: auto;
    max-width: 1440px;
    position: sticky;
    top: 54px;
    width: 100%;
    z-index: 0;
    background-color: #003594;
    border-bottom: 1px solid #bababa;
}
.flex {
    -webkit-text-size-adjust: 100%;
    --sa-uid: '0-50804ad4-9f89-4ae5-4f1f-35566b298ffd';
    font-family: Lato;
    font-size: 16px;
    font-weight: 400;
    color: #222223;
    line-height: 1.4;
    display: flex;
    justify-content: center;
}

.anchored-nav__anchor{
    -webkit-text-size-adjust: 100%;
    --sa-uid: '0-50804ad4-9f89-4ae5-4f1f-35566b298ffd';
    font-family: Lato;
    font-weight: 400;
    background-color: transparent;
    text-decoration: none;
    line-height: 1.5;
    padding-left: 16px;
    padding-right: 16px;
    display: block;
    padding-bottom: 12px;
    padding-top: 12px;
    position: relative;
    text-align: center;
    font-size: 1rem;
    border-color: #bababa;
    color: #fff !important;        
}
.anchored-nav__anchor:not(:first-child) {
    border-left-style: solid;
    border-left-width: 1px;
}

.show-at-medium {
    display: block !important;
}

.hide-at-medium {
    display: none !important;

    select {
        border-radius: 4px;
    }
}

${maxWidth.medium`
    .hide-at-medium {
        padding-top: 10px;
        padding-bottom: 10px;
        display: flex !important;
        justify-content: center;
        
        .custom-select__select {
            width: 280px;
            height: 38px;
            font-size: 16px;
            color: #003594;
            padding-right: 34px;
        }    
    }

    .show-at-medium {
        display: none !important;
    }
    select {
        width: 231px;
        height: 21px;
        margin: 0 5.1px 0 0;
        font-family: Lato;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: italic;
        line-height: 1.31;
        letter-spacing: normal;
        color: #003594;        
    }    
`}

${maxWidth.small`

`}
`
